<template>
  <div class="view-home">
    <Banner>
      <div class="home-banner">
        <div class="home-banner-con">
          <h3>AI智能起名神器 海量好名精准推荐</h3>
          <p>超过5万家创业者成功找到满意公司名称</p>
        </div>
      </div>
    </Banner>
    <div class="home-form">
      <FormWrap>
        <FormItem title="" type="location">
          <Location @change="locationChange"></Location>
        </FormItem>
        <FormItem title="" type="industry">
          <Industry placeholder="请选择所属行业，如：网络科技"></Industry>
        </FormItem>
        <FormItem title="" type="name">
          <el-input
            class="inline-input"
            v-model="name"
            placeholder="请输入名称要求（非必填）"
            size="small"
            style="width: 212px"
          ></el-input>
        </FormItem>
        <div ref="buttonWrap" style="height: 68px">
          <div class="fixed-button-wrap" :class="{ fixed: isFixed }">
            <el-button class="form-btn" type="primary" @click="handleClick">
              获取好名
            </el-button>
          </div>
        </div>
        <p class="com-form-con-link">
          <router-link to="/check">已有公司名称，去核名 >>></router-link>
        </p>
      </FormWrap>
    </div>

    <div class="line-item line-1">
      <div class="wp line-title">
        每天服务2000+创业者
      </div>
      <div class="wp line-con">
        <div
          class="line-1-item"
          v-for="(companyItem, companyIndex) in companyData"
          :key="companyIndex"
        >
          <div>
            <ul class="clearfix table-line">
              <li>名称</li>
              <li>联系方式</li>
              <li>推荐好名</li>
              <li style="width: 34%;margin-left: -13%;margin-right: -10%;">
                <i class="el-icon-star-on"></i>注册成功率
              </li>
            </ul>
          </div>
          <div>
            <el-carousel
              height="170px"
              direction="vertical"
              indicator-position="none"
              :autoplay="true"
            >
              <el-carousel-item
                v-for="(item, index) in companyItem"
                :key="index"
              >
                <ul class="clearfix" v-for="(v, k) in item" :key="k">
                  <li>{{ v[0] }}</li>
                  <li>{{ v[1] }}</li>
                  <li>{{ v[2] }}</li>
                  <li>
                    <rate :length="rateValue(v)" :value="2" :readonly="true" />
                  </li>
                </ul>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
    </div>
    <div class="line-item line-2">
      <div class="wp line-title">
        起名优势
      </div>
      <div class="wp line-con clearfix">
        <div>
          <img src="../assets/images/home-line2-img1.png" />
          <h3>行业范围联想</h3>
          <p>与行业强关联<br />名称定义品牌气质</p>
        </div>
        <div>
          <img src="../assets/images/home-line2-img2.png" />
          <h3>AI智能计算</h3>
          <p>
            规避取名敏感词汇推荐个性名称，<br />与创业者强者关联，定制化取名
          </p>
        </div>
        <div>
          <img src="../assets/images/home-line2-img3.png" />
          <h3>大数据分析系统</h3>
          <p>结婚工商数据实时推荐成功率高的公司名称</p>
        </div>
      </div>
    </div>
    <div class="line-item line-3">
      <div class="wp line-title">
        起名注意事项
      </div>
      <div class="wp line-con clearfix">
        <div class="line-3-item">
          <div>
            <img
              src="../assets/images/home-line3-img1.png"
              width="79"
              height="70"
            />
          </div>
          <b>不能使用繁体字、数字、英语</b>
          <span>公司名称只能使用简体中文</span>
        </div>
        <div class="line-3-item">
          <div>
            <img
              src="../assets/images/home-line3-img2.png"
              width="69"
              height="75"
            />
          </div>
          <b>不不能使用名人字号、宗教色彩等</b>
          <span>比如“马化腾”有限公司，“赞比亚”有限公司</span>
        </div>
        <div class="line-3-item">
          <div>
            <img
              src="../assets/images/home-line3-img3.png"
              width="61"
              height="75"
            />
          </div>
          <b>不能使用行业通用性词汇</b>
          <span>如：“广州电脑科技有限公司”不能注册为公司名字</span>
        </div>
        <div class="line-3-item">
          <div>
            <img
              src="../assets/images/home-line3-img4.png"
              width="77"
              height="75"
            />
          </div>
          <b>尽量不使用地区名称（简称）</b>
          <span>如：广州、北京、京等不能注册为公司名字</span>
        </div>
      </div>
    </div>
    <div class="line-item line-4">
      <div class="wp line-title">
        公司注册流程
      </div>
      <div class="wp line-con clearfix">
        <div>
          <img src="../assets/images/home-line4-img1.png" />
          <span>资料收集</span>
        </div>
        <div>
          <img src="../assets/images/home-line4-img2.png" />
          <span>工商核名</span>
        </div>
        <div>
          <img src="../assets/images/home-line4-img3.png" />
          <span>系统申报</span>
        </div>
        <div>
          <img src="../assets/images/home-line4-img4.png" />
          <span>工商交件</span>
        </div>
        <div>
          <img src="../assets/images/home-line4-img5.png" />
          <span>领取执照</span>
        </div>
      </div>
    </div>
    <el-dialog
      title="起名结果"
      :visible.sync="$store.state.giveNameDialogStatus"
      :append-to-body="true"
      class="give-name-dialog"
    >
      <!-- <div class="filter-header">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="80px"
          size="medium"
          class="clearfix"
        >
          <el-form-item label="字号字数">
            <el-select v-model="filterForm.hotCount" placeholder="请选择">
              <el-option
                v-for="item in hotCountList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="组织形式">
            <el-select v-model="filterForm.companyType" placeholder="请选择">
              <el-option
                v-for="item in orgList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="好名筛选">
            <el-input
              v-model="filterForm.search"
              autocomplete="off"
              placeholder="请输入一个您想包含的汉字"
              maxlength="1"
            ></el-input>
          </el-form-item>
          <el-button
            type="primary"
            size="medium"
            @click="getData(1)"
            style="width: 100%; margin-top: 10px"
          >
            筛选
          </el-button>
        </el-form>
      </div> -->
      <div class="filter-result">
        <div class="clearfix" v-for="(item, index) in nameViewNew" :key="index">
          <div class="filter-result-item">
            <p class="filter-result-html" v-html="item.name"></p>
            <el-button type="primary" size="mini" @click="checkName(item)">
              核名
            </el-button>
          </div>
        </div>
      </div>
      <!-- <div class="filter-result-footer">
        <el-button size="medium" @click="getMore">换一批</el-button>
      </div> -->
    </el-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapMutations, mapState, mapActions } from "vuex";
import Banner from "../components/Banner.vue";
import FormWrap from "../components/FormWrap.vue";
import FormItem from "../components/FormItem.vue";
import Location from "../components/Location.vue";
import companyData from "../utils/companyData";
import orgList from "../utils/orgList";
import Industry from "../components/Industry";

export default {
  name: "home",
  components: {
    Industry,
    Banner,
    FormWrap,
    FormItem,
    Location
  },
  computed: {
    ...mapState({
      isLogin: state => state.isLogin,
      nameViewNew: state => state.nameViewNew
    }),
    companyData() {
      const temp = [[]];
      for (let i = 0, len = companyData.length; i < len; i += 5) {
        temp[0].push(companyData.slice(i, i + 5));
      }
      return temp;
    }
  },
  data() {
    return {
      name: "",
      form: {},
      filterForm: {
        hotCount: "1",
        companyType: "3",
        search: ""
      },
      ruleForm: {},
      rules: {},
      hotCountList: [
        {
          label: "不限",
          value: "1"
        },
        {
          label: "两个字",
          value: "2"
        },
        {
          label: "三个字",
          value: "3"
        },
        {
          label: "四个字",
          value: "4"
        },
        {
          label: "五个字",
          value: "5"
        },
        {
          label: "六个字",
          value: "6"
        }
      ],
      orgList: orgList,
      curPage: 1,
      offsetTop: 0,
      isFixed: false,
      scrollFixed: true
    };
  },
  created() {},
  methods: {
    ...mapMutations([
      "setLoginDialogStatus",
      "setRegisterDialogStatus",
      "setGiveNameResultDialogStatus"
    ]),
    ...mapActions(["getNameViewNew", "getCheckNameViewNew"]),
    handleClick() {
      if (this.isFixed) {
        window.scrollTo(0, 0);
        this.isFixed = false;
      }
      if (!this.$store.state.location.c_id) {
        return this.$message({
          type: "error",
          message: "请选择城市"
        });
      }
      if (!this.$store.state.industry) {
        return this.$message({
          type: "error",
          message: "请选择行业"
        });
      }

      if (this.name.length > 20) {
        return this.$message({
          type: "error",
          message: "名称要求最大输入20个文字"
        });
      }
      if (this.isLogin) {
        this.showDialog();
      } else {
        this.setRegisterDialogStatus({ status: true, isSimple: true });
      }
    },
    getData(currentPage) {
      const params = {
        cityGroup: "",
        companyType: this.filterForm.companyType,
        hotCount: this.filterForm.hotCount,
        industryId: this.$store.state.industry.i_id,
        cityId: this.$store.state.location.c_id,
        industry: this.$store.state.industry.i_title,
        curPage: currentPage || this.curPage,
        limit: 5,
        sub_content: "落地页-起名",
        sub_button: "免费起名",
        search: this.filterForm.search,
        name_demand: this.name
      };
      this.getNameViewNew(params);
    },
    showDialog() {
      this.$store.commit("setGiveNameDialogStatus", true);
    },
    getMore() {
      this.curPage++;
      this.getData();
    },
    checkName(v) {
      // this.getCheckNameViewNew({
      //   cityId: this.$store.state.location.c_id,
      //   city: v.cp,
      //   industryId: this.$store.state.industry.i_id,
      //   industry: this.$store.state.industry.i_title,
      //   cityGroup: v.cityGroup,
      //   companyType: this.filterForm.companyType,
      //   hotword: v.title,
      //   sub_content: "落地页-起名",
      //   sub_button: "免费起名",
      //   companyName: v.companyName
      // }).then(res => {
      //   if (res.data.status) {
      //     this.setGiveNameResultDialogStatus(true);
      //   } else {
      //     this.$message({
      //       type: "error",
      //       message: res.data.result
      //     });
      //   }
      // });
      this.getCheckNameViewNew({
        // cityId: this.$store.state.location.c_id,
        // city: v.cp,
        // industryId: this.$store.state.industry.i_id,
        // industry: this.$store.state.industry.i_title,
        // cityGroup: v.cityGroup,
        // companyType: this.filterForm.companyType,
        // hotword: v.title,
        // sub_content: "落地页-起名",
        // sub_button: "免费起名",
        word: this.font || v.word,
        company_name: v.name
      }).then(res => {
        if (res.data.status) {
          this.setGiveNameResultDialogStatus(true);
        } else {
          this.$message({
            type: "error",
            message: res.data.result
          });
        }
      });
    },
    rateValue(v) {
      let obj = {
        高: 3,
        中: 2,
        低: 1
      };
      return obj[v[3]];
    },
    locationChange(val) {},
    bindScrollFixed() {
      this.isFixed = window.scrollY >= this.offsetTop;
    }
  },
  watch: {
    "$store.state.giveNameDialogStatus": function(val) {
      if (val) {
        this.getData(1);
      }
    },
    name(newval) {
      if (newval) {
        this.$store.commit("setWord", newval);
      }
    }
  },
  mounted() {
    document.title = "公司起名";
    this.$nextTick(() => {
      if (this.scrollFixed) {
        this.offsetTop = 461; //this.$refs.buttonWrap.offsetTop;
        window.addEventListener("scroll", this.bindScrollFixed);
      }
    });
  },
  beforeDestroy() {
    if (this.scrollFixed) {
      window.removeEventListener("scroll", this.bindScrollFixed);
    }
  }
};
</script>
<style lang="scss">
.view-home {
  .home-banner {
    padding: 18px 0;
    .home-banner-con {
      text-align: center;
      color: #fff;
      h3 {
        font-size: 20px;
        margin-bottom: 10px;
      }
      p {
        font-size: 12px;
      }
    }
  }
  .home-form {
    background: #fff;
    margin: -145px 25px 12px;
    position: relative;
    z-index: 4;
    border-radius: 4px;
    .select-location,
    .select-industry {
      .select-text,
      .select-text i {
        height: 48px;
        line-height: 48px;
      }
    }
  }
  .line-item {
    margin: 0 25px 6px;
    .line-title {
      font-size: 18px;
      padding: 18px 0;
      text-indent: 16px;
      &:before {
        content: "";
        float: left;
        background: #207bf9;
        width: 6px;
        height: 25px;
      }
    }
    &.line-1 {
      position: relative;
      z-index: 1;
      .line-1-item {
        height: 240px;
        background: rgba(255, 255, 255, 1);
        border-radius: 4px;
        overflow: hidden;
        > div {
          text-align: center;
          &:first-of-type {
            color: #222;
            margin: 0 10px;
            border-bottom: 1px solid #eee;
            li {
              height: 34px;
              line-height: 34px;
              font-size: 10px;
              font-weight: 600;
            }
            .el-icon-star-on {
              margin: 0;
            }
          }
          &:last-of-type {
            padding: 10px 13px;
          }
          .table-line {
            height: 34px;
            line-height: 34px;
            overflow: hidden;
          }
          li {
            float: left;
            height: 34px;
            line-height: 34px;
            color: rgba(51, 51, 51, 1);
            overflow: hidden;
            font-size: 12px;
            transform: scale(0.94);
            &:nth-of-type(1) {
              width: 13%;
            }
            &:nth-of-type(2) {
              width: 25%;
            }
            &:nth-of-type(3) {
              width: 46%;
            }
            &:nth-of-type(4) {
              width: 16%;
            }
          }
        }
        .Rate__star {
          padding: 0;
          color: #25ce25;
          .icon {
            vertical-align: -1px;
            width: 10px;
            height: 10px;
            margin: 0 auto;
          }
        }
      }
    }
    &.line-2 {
      .line-con {
        background: #fff;
        border-radius: 4px;
        text-align: left;
        > div {
          margin: 0 15px;
          border-bottom: 1px solid #ddd;
          padding: 25px 0;
          height: 60px;
          &:last-of-type {
            border: none;
          }
        }
        img {
          width: 60px;
          height: 60px;
          float: left;
          margin: 0 24px 0 16px;
        }
        h3 {
          font-size: 15px;
          margin-bottom: 6px;
        }
        p {
          font-size: 10px;
          color: #777777;
          line-height: 1.4;
        }
      }
    }
    &.line-3 {
      .line-con {
        background: #fff;
        border-radius: 4px;
        padding: 8px 0;
      }
      .line-3-item {
        width: 50%;
        float: left;
        text-align: center;
        padding: 16px 20px 16px;
        box-sizing: border-box;
        &:nth-of-type(2n) {
          margin-right: 0;
        }
        b,
        span {
          display: block;
          text-align: center;
          line-height: 1.4;
        }
        b {
          font-size: 15px;
          color: rgba(51, 51, 51, 1);
          margin-bottom: 7px;
        }
        span {
          font-size: 10px;
          color: #777777;
          transform: scale(0.9, 0.9);
          margin: 0 -12px;
        }
        div {
          padding: 12px;
          width: 30px;
          height: 30px;
          border: 1px solid #eee;
          border-radius: 100%;
          margin: 0 auto 10px;
        }
        img {
          width: 30px;
          height: 30px;
          vertical-align: top;
        }
      }
    }
    &.line-4 {
      margin-bottom: 24px;
      .line-con {
        display: flex;
        flex-direction: row;
        background: #fff;
        border-radius: 4px;
        padding: 20px 10px;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        > div {
          flex: 1;
          &:last-of-type {
            margin-right: 0;
          }
        }
        img,
        span {
          display: block;
          text-align: center;
          margin: 0 auto;
        }
        img {
          width: 33px;
          height: 33px;
          margin-bottom: 16px;
        }
      }
    }
  }
}
.fixed-button-wrap.fixed {
  background: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 20px 20px 0;
  box-sizing: border-box;
  box-shadow: 0 0 5px #aaa;
}
.give-name-dialog {
  .el-dialog {
    width: 870px;
  }
  .el-dialog__body {
    padding-top: 6px;
  }
  .filter-header {
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    padding: 14px 0;
  }
  .el-form-item {
    /*display: inline-block;*/
    margin: 0 0 5px;
    .el-select {
      width: 100%;
    }
  }
  .filter-result {
    height: 230px;
    box-sizing: border-box;
    padding: 20px 0 0;
    overflow: hidden;
  }
  .filter-result-item {
    padding: 0 10px;
    box-sizing: border-box;
    margin-bottom: 14px;
    overflow: hidden;
    .filter-result-html {
      float: left;
      span {
        color: red;
      }
    }
    .el-button {
      float: right;
    }
  }
  .filter-result-footer {
    text-align: center;
    .el-button {
      width: 186px;
    }
  }
}

.Rate {
  text-align: center;
  /*text-indent: 14px;*/
  .Rate__star {
    cursor: default !important;
    &:focus {
      outline: none;
    }
  }
}
</style>
